
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)
  const hasList = (list) => list.length > 0
  const { costCentres, makes, models, expectedDeliveryDates, poRaisedDates, deliveryLocations } = filters
  // const statusOptions = ['Overdue', 'Upcoming', 'Planned']

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography
          variant="h5">
          Filters
        </Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={[{ label: 'No cost centre', value: '-' }, ...costCentres]}
            value={filtered.costCentre}
            onChange={onSelect('costCentre')}
            includeEmptyOption
            emptyOptionLabel="All cost centres" />
        )}
        {hasList(makes) && (
          <MuiFormSelect
            id="make"
            label="Make"
            options={makes}
            value={filtered.make}
            onChange={onSelect('make')}
            includeEmptyOption />
        )}
        {hasList(models) && (
          <MuiFormSelect
            id="model"
            label="Model"
            options={models}
            value={filtered.model}
            onChange={onSelect('model')}
            includeEmptyOption />
        )}
        {hasList(expectedDeliveryDates) && (
          <MuiFormSelect
            id="expectedDeliveryDate"
            label="Expected Delivery Date"
            options={expectedDeliveryDates}
            value={filtered.expectedDeliveryDate}
            onChange={onSelect('expectedDeliveryDate')}
            includeEmptyOption />
        )}
        {hasList(poRaisedDates) && (
          <MuiFormSelect
            id="poRaisedDate"
            label="P.O raised"
            options={poRaisedDates}
            value={filtered.poRaisedDate}
            onChange={onSelect('poRaisedDate')}
            includeEmptyOption />
        )}
        {hasList(deliveryLocations) && (
          <MuiFormSelect
            id="deliveryLocation"
            label="Delivery Location"
            options={deliveryLocations}
            value={filtered.deliveryLocation}
            onChange={onSelect('deliveryLocation')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
